import { heroFeatures } from "@/mocks/articles";

export default function FeatureWorld() {
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900 whitespace-nowrap">
              三大栏目
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              从三个角度，读懂洞洞杂货铺
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-700">
            世界观解析带你俯瞰全局，角色图鉴帮你认识每个人，设定百科则随查随用。
            三条路径互为补充，适合不同阅读习惯的你。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {heroFeatures.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/80 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">
                  {item.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                  前往查看
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}